import '../../shared/app/vendor/marked-extensions';
import { configModule } from './config/config';
import { loadingPanelServiceModule } from '../../shared/app/services/loading-panel/loading-panel';
import { autoRetryInterceptorModule } from '../../shared/app/interceptors/auto-retry-interceptor/auto-retry-interceptor';
import { authInterceptorModule } from '../../shared/app/interceptors/auth-interceptor/auth-interceptor';
import { railsInterceptorModule } from '../../shared/app/interceptors/rails-interceptor/rails-interceptor';
import { exceptionHandlerServiceModule } from '../../shared/app/services/exception-handler/exception-handler';
import { productMaintenanceServiceModule } from '../../shared/app/services/product-maintenance-service/product-maintenance-service';
import { allRoutesModule } from './routes/routes';
import { stateSpecificComponentModule } from '../../shared/app/components/state-specific/state-specific';
import { allModelsModule } from '../../shared/app/models/models';
import { uiLayoutComponentModule } from '../../shared/app/components/ui-layout/ui-layout';
import { formsComponentModule } from '../../shared/app/components/forms/forms';
import { tabsComponentModule } from '../../shared/app/components/tabs/tabs';
import { modalComponentModule } from '../../shared/app/components/modal/modal';
import { tooltipComponentModule } from '../../shared/app/components/tooltip/tooltip';
import { trackerServiceModule } from '../../shared/app/services/tracker-service/tracker-service';
import { dropdownComponentModule } from '../../shared/app/components/dropdown/dropdown';
import { uiBootstrapButtonsModule } from '../../shared/app/vendor/ui-bootstrap-buttons-module';
import { loadingBarModule } from '../../shared/app/vendor/loading-bar-module';
import {
  ngAnimateModule,
  ngAriaModule,
  ngSanitizeModule,
} from '../../shared/app/vendor/angular-modules';
import { releaseAlertServiceModule } from '../../shared/app/services/release-alert-service/release-alert-service';

// Implement fullstory init here for asses(Datadog rum replacement)
angular
  .module('qualified', [
    // general includes
    ngAriaModule,
    ngSanitizeModule,
    ngAnimateModule,
    loadingBarModule,
    loadingPanelServiceModule,

    // configuration modules
    configModule,
    autoRetryInterceptorModule,
    authInterceptorModule,
    railsInterceptorModule,

    // remote exception handling
    exceptionHandlerServiceModule,

    // routing setup
    allRoutesModule,
    stateSpecificComponentModule,

    // all models
    allModelsModule,

    // alert on releases
    releaseAlertServiceModule,
    productMaintenanceServiceModule,

    // bootstrap and common components
    uiBootstrapButtonsModule,
    dropdownComponentModule,
    uiLayoutComponentModule,
    formsComponentModule,
    tabsComponentModule,
    modalComponentModule,
    tooltipComponentModule,

    //analytics
    trackerServiceModule,
  ])
  .controller('AssessAppCtrl', function () {
    // nothing to do
  });
